import { Dropdown } from 'primereact/dropdown';
import { classNames } from 'primereact/utils';
import { useEffect, useState } from 'react';

interface Props {
    name: string,
    add :(param:string) => void,
    type :string,
    error:boolean
    init:{
      name:string
    } | null
}


export const List = ({name,add,type,error,init}:Props) => {
    const [value, setValue]  = useState<any>(init);
    const [values,setValues] = useState<any>(null);

    const onValueChange = (e: { value: any}) => {
        setValue(e.value);
        add(e.value.name)
    }

    useEffect(() => {
        setValues(type.replace('choice',"").replace("[","").replace("]","").split(";").map((e:any) => ({name: e})))
    },[type])

    return (
        <>
            <label
            htmlFor="dataProduct"
            className={classNames({
              "p-error": error && value === null,
              labelSourceExterne: !error,
            })}
          >
            {name}<span className="star">*</span>
          </label>
        <Dropdown value={value} options={values} onChange={onValueChange} optionLabel="name"  
                                        className={classNames({
                                            "p-invalid": error && value === null,
                                            fieldSourceExt: true,
                                          })} />
        </>
    )
}